// Formats: '%,n', '$,n', '$x,n', 'f,n', 'i,n'
// operations: 'last(a)', prod(a,b), ratio(a,b)

export default {
  '***': {
    '***': [
        {
          metric: 1,
          inHeader: true,
          label: 'Ad Effect Score',
          rowType: 'demphasized',
          dataFormat: '.,0',
          reverseStat: false,
          minSampleSize: 1
        },
        {
          label: 'IN-MARKET POTENTIAL',
          rowType: 'hb0'
        },
        {
          label: 'IMPACT',
          rowType: 'h0'
        },
        {
          metric: 2,
          label: 'Lift to Impression',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 3,
          label: 'Lift to Consideration',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 4,
          label: 'Message Importance',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 5,
          label: 'Net Actions',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 6,
          label: 'Talk about the ad to colleagues or employees',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 7,
          label: 'Go online for more information (including reviews/ratings)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 8,
          label: 'Follow or otherwise interact with the brand on social media',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 9,
          label: 'Contact this brand directly (call, email, DM, etc.)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 10,
          label: 'Go to a retail store that sells these products',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 11,
          label: 'Purchase products/services from this brand',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 12,
          label: 'Take advantage of an offer or promotion',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },


        {
          label: 'CREATIVE DIAGNOSTICS',
          rowType: 'hb0'
        },
        {
          label: 'BRANDING',
          rowType: 'h0'
        },
        {
          metric: 62,
          label: 'Ad Recall',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 13,
          label: 'Aided Brand Recognition',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 14,
          label: 'Ease of Branding',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 15,
          label: 'Unique to this Brand',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          label: 'APPEAL',
          rowType: 'h0'
        },
        {
          metric: 16,
          label: 'Likes',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 17,
          label: 'Dislikes',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          label: 'CREATIVE EFFICIENCY',
          rowType: 'h0'
        },
        {
          metric: 18,
          label: 'Brand Connection',
          rowType: 'dh0',
          dataFormat: '.,0',
          reverseStat: false
        },
        {
          metric: 19,
          label: 'Makes me feel closer to the brand',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 20,
          label: 'Portrays a brand I want to associate with',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 21,
          label: 'Fulfills my business’s needs',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 22,
          label: 'Trustworthy',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 23,
          label: 'Reliable',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 24,
          label: 'Makes me feel good about this brand',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 25,
          label: 'Brand that supports local businesses',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },


        {
          metric: 26,
          label: 'Cognitive Connection',
          rowType: 'dh0',
          dataFormat: '.,0',
          reverseStat: false
        },

        {
          metric: 27,
          label: 'Tells me something new',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 28,
          label: 'Credible from this brand',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 29,
          label: 'Informative',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 30,
          label: 'Good fit with the brand',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 31,
          label: 'Makes me think of the brand in a new way',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 32,
          label: 'Gave too much information',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 33,
          label: 'Presents information at a good pace',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 34,
          label: 'Clear',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 35,
          label: 'Confusing',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 36,
          label: 'Engagement',
          rowType: 'dh0',
          dataFormat: '.,0',
          reverseStat: false
        },

        {
          metric: 37,
          label: 'Worth talking about',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 38,
          label: 'Clever',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 39,
          label: 'Attention grabbing',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 40,
          label: 'More unique offers',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 41,
          label: 'Entertaining',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 42,
          label: 'Humorous',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 43,
          label: 'Unique',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 44,
          label: 'Heartwarming',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 45,
          label: 'Memorable',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: 46,
          label: 'Tired of seeing this ad',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },

        {
          metric: 47,
          label: 'Category Connection',
          rowType: 'dh0',
          dataFormat: '.,0',
          reverseStat: false
        },

        {
          metric: 48,
          label: 'Good value for the money',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 49,
          label: 'Makes me feel secure',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 50,
          label: 'Values its customers',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 51,
          label: 'Innovative technology',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 52,
          label: 'Relevance',
          rowType: 'dh0',
          dataFormat: '.,0',
          reverseStat: false
        },
        {
          metric: 53,
          label: 'Spoke directly to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 54,
          label: 'Relevant to my business',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 55,
          label: 'Provides peace of mind',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 56,
          label: 'Product Connection',
          rowType: 'dh0',
          dataFormat: '.,0',
          reverseStat: false
        },
        {
          metric: 57,
          label: 'Products/features that are different than others',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 58,
          label: 'Has products/services that work well together',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 59,
          label: 'Offers flexible plans to meet a variety of needs',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 60,
          label: 'Provides a great entertainment experience',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 61,
          label: 'Allows my business to save by bundling business services',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false,
          labelStyle : 'italic'
        },
        {
          metric: -1,
          label: '',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        }

      ]
  },
};



// WEBPACK FOOTER //
// ./src/app/configuration/Optimum/config/components/scorecard/MetricsLabels/metricsLabels.js